import { useNavigate, useLocation } from "@entry/navigation";

import { Back } from "@assets";
import { AnalyticsEvent, Routes } from "@ctypes";
import { Analytics } from "@services";
import { getRouteForPath } from "@utils";
import { Container, Placeholder } from "./styles";

export const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const canGoBack = window.history.length > 1 && location;

  if (!canGoBack) return <Placeholder />;

  const goBack = () => {
    // Inside the entry/onboarding step machine location.pathname is the current
    // step, so this resolves to the screen the user backed out of rather than
    // the flow's single router path.
    Analytics.track(AnalyticsEvent.BackButtonPressed, {
      screen: getRouteForPath(location.pathname),
    });

    if (location.pathname === Routes.EmailLogin || location.pathname === Routes.SignUp) {
      navigate(Routes.Auth, { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <Container onClick={goBack}>
      <Back />
    </Container>
  );
};
